import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useUser } from '../../components/UserContext.tsx';
import { useCrypto } from '../../components/CryptoContext.tsx';
import { expressURL, getAuthHeaders } from '../../utils/networkUtils';
import { firstGrapheme } from '../../utils/singleEmoji.ts';

function Account() {
  const { activeUser, fetchUser, fetchAllUsers } = useUser();
  const { changeLoginPassword } = useCrypto();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [emoji, setEmoji] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    setEmoji(firstGrapheme(activeUser?.emoji || ''));
  }, [activeUser?.emoji]);

  const handleEmojiSave = async (e) => {
    e.preventDefault();
    try {
      await axios.patch(`${expressURL()}/auth/profile`, { emoji: firstGrapheme(emoji) }, getAuthHeaders());
      await fetchUser();
      await fetchAllUsers();
      setMessage('Emoji saved.');
    } catch (error) {
      const detail = error.response?.data;
      const text = typeof detail === 'string' ? detail : (detail?.error || error.message || 'unknown error');
      setMessage('Error: ' + text);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await changeLoginPassword(currentPassword, newPassword);
      setMessage('Password changed.');
      setCurrentPassword('');
      setNewPassword('');
    } catch (error) {
      const detail = error.response?.data;
      const text = typeof detail === 'string' ? detail : (detail?.error || error.message || 'unknown error');
      setMessage('Error: ' + text);
    }
  };

  if (!activeUser) {
    return (
      <div className='main-content'>
        <Container className='mb-5'>
          <p className="mt-3">Log in to change your password.</p>
        </Container>
      </div>
    );
  }

  return (
    <div className='main-content'>
      <Container className='mb-5'>
        <h1 className="display-4 mb-3 mt-3">Account</h1>
        <p>{activeUser.fullName} · {activeUser.email}</p>
        <h2 className="h5 mt-4 mb-3">Avatar emoji</h2>
        <form onSubmit={handleEmojiSave}>
          <Row>
            <Col sm={3} md={2} xxl={1}>
              <Form.Label>Emoji</Form.Label>
            </Col>
            <Col className='mb-3'>
              <Form.Control
                type="text"
                name="emoji"
                value={emoji}
                onChange={(e) => setEmoji(firstGrapheme(e.target.value))}
                placeholder="One emoji"
              />
            </Col>
          </Row>
          <button className='btn btn-primary' type="submit">Save emoji</button>
        </form>
        <h2 className="h5 mt-4 mb-3">Change login password</h2>
        <form onSubmit={handleSubmit}>
          <Row>
            <Col sm={3} md={2} xxl={1}>
              <Form.Label>Current</Form.Label>
            </Col>
            <Col className='mb-3'>
              <Form.Control
                type="password"
                autoComplete="current-password"
                name="current-password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                required
              />
            </Col>
          </Row>
          <Row>
            <Col sm={3} md={2} xxl={1}>
              <Form.Label>New</Form.Label>
            </Col>
            <Col className='mb-3'>
              <Form.Control
                type="password"
                autoComplete="new-password"
                name="new-password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
            </Col>
          </Row>
          <button className='btn btn-primary' type="submit">Save password</button>
        </form>
        {message && <p className="mt-3">{message}</p>}
        <p className="mt-4">
          Encryption keys are on <Link to="/settings">Settings</Link>.
        </p>
      </Container>
    </div>
  );
}

export default Account;
